import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppkulturComponent } from './app-kultur/app-kultur.component';
import { AppReinhriedComponent } from './app-reinhried/app-reinhried.component';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  {
    path: '',
    component: AppkulturComponent,//HomeComponent,
  
  },
  {
  path: 'kultur',
  component: AppkulturComponent,
  },
  {
    path: 'rhried',
    component: AppReinhriedComponent,
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
